import React from "react";

export default function OutOfStockMessage() {
  return <div className="text-danger">This product is out of stock, please wait for it to become available.</div>;
}